export default{

    props:{
        id: {
            type: String,
            default: null
        },
        domain: {
            type: String,
            default: null
        },
        name: {
            type: String,
            default: null
        },
        hash: {
            type: String,
            default: null
        },
        url: {
            type: String,
            default: null

        }
    },
    methods: {

        htmlLoaded(){
            setTimeout(()=>{

               // console.log("REFS",this.$refs)
                this.initVata()
            },300)
        },

        htmlLoadedCustom(){

        },


        transformHtml(html){
            return html.replaceAll("bgvata",this.elementId)
            return html
        },


        uuidv4() {
            return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
                return v.toString(16);
            });
        },

        getHtml(){

            var lang="de"

            if(window.appSettings && window.appSettings.appLanguage){
                lang=window.appSettings.appLanguage
            }

            if(!this.url){
                var url = 'https://'+this.domain + '/api/customer/widget/'+this.id + '/' + this.hash
            }else{
                var url = this.url
            }

            axios.get(url,
                {
                    params: {
                        currentUrl: window.location.href,
                        lang: lang
                    }
                }
                ).then(response => {

                    this.rendered=false
                   // console.log(response.data)
                    this.html = this.transformHtml(response.data.html)
                if(response.data.css_url){
                   // console.log("CSS URL",response.data.css_url)

                        var link = document.createElement('link');
                        link.rel = 'stylesheet';
                        link.href = response.data.css_url;
                        document.head.appendChild(link);
                        console.log("CSS Link",link)

                }

               
                this.$nextTick(()=>{
                    this.htmlLoaded()
                    this.rendered = true
                    this.$nextTick(()=>{
                        this.htmlLoadedCustom()
                    })
                })




                }
            ).catch(error => {
                console.error(error)

            })
        },


        initVata() {
            $("." + this.elementId).each(function (index) {
                var ref = document.querySelector(["[id='" + $(this).attr('id') + "']"]);
                ;


                var colorData = $(this).data('color')
                console.log('[REF2]', ref)

                var indexName = 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                    var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
                    return v.toString(16);
                });

                //  var ref = null
                WAVES({
                    el: ref,
                    THREE: THREE,
                    mouseControls: false,
                    touchControls: false,
                    gyroControls: false,
                    minHeight: 400.00,
                    minWidth: 1200.00,
                    scale: 1.600,
                    scaleMobile: 1.00,
                    color: colorData,
                    waveHeight: Math.floor(Math.random() * 7) + 3,
                    waveSpeed: Math.floor(Math.random() * 0.8) + 0.8,
                    zoom: 3
                })
            });
        },
        getDetailItem(url,eventItemTime,eventItemType){

            this.showDetailModal=true
            this.eventDetail=null
            this.eventItemTime=eventItemTime
            this.eventItemType=eventItemType
            axios.get(url)
                .then((response) => {
                    //  console.log(response.data)
                    console.log("[SCHEDULE]Finding Position in index");

                    Vue.set(this, "eventDetail", response.data);


                    Vue.nextTick().then(() => {
                        this.loadingDetails = false;
                        console.log("[POSTER] Latex Queue")
                        setTimeout(()=>{
                            //   MathJax.Hub.Queue(["Typeset",MathJax.Hub]);
                        },200)
                    });
                })
                .catch((error) => {
                    console.log(error);

                });
        },
        autoRefresh(){
            setTimeout(()=>{
                if(this.reload){
                    this.getHtml()
                }

                this.autoRefresh()
            },10000)
        }
    },
    computed: {
        getEventItemIcon(){
            var css=[]
            if(this.eventDetail && this.eventDetail.eventItemType && this.eventDetail.eventItemType.key_icon){
                css.push("fal "+this.eventDetail.eventItemType.key_icon.icon)
            }else{
                css.push("fas fa-circle-notch fa-spin")
            }

            return css
        },
    },
    data() {
        return {
            html:'<div class="text-4xl p-8 flex justify-center w-full text-gray-400"><i class="fal fa-circle-notch fa-spin"></i></div>',
            rendered:true,
            reload:false,
            showDetailModal:false,
            eventDetail:null,
            eventItemTime:null,
            eventItemType:null,
            elementId:null,
            vantaEffect:[]
        }
    },

    mounted() {
        this.elementId="bg_" + this.uuidv4()

        this.getHtml()



    }
}